export default "__VITE_ASSET__D3KRS60f__"